import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const createpersonalgoal = createAsyncThunk(
    'performance/createpersonalgoal',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/performance/personalgoal`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Personal Goal');
        }
    }
);

export const fetchpersonalgoalById = createAsyncThunk(
    'performance/fetchpersonalgoalById',
    async ( {Id}: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/personalgoal/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Personal Goal');
        }
    }
);